module.exports = __webpack_public_path__ + "media/images/painter-img-1-581f9bfa78a787b5121440b4cdb63558.jpg";